import { put, takeEvery, all, select } from 'redux-saga/effects';
import { showNotification } from 'react-admin';
import { getFullPolicies, getGroupsWithUsers, getPolicies/*, getUsers*/ } from './actions';
import { RESET_MFA_SUCCESS, RESET_MFA_FAILURE, INSERT_OR_UPDATE_USER_GROUPS_SUCCESS, INSERT_OR_UPDATE_USER_GROUPS_FAILURE, DELETE_USER_GROUPS_SUCCESS, DELETE_USER_GROUPS_FAILURE, userGroupInit, INSERT_USER_SUCCESS, userInit, DELETE_USER_SUCCESS, INSERT_OR_UPDATE_POLICY_SUCCESS, DELETE_POLICY_SUCCESS, Policy, INSERT_OR_UPDATE_POLICY_FAILURE, INSERT_USER_FAILURE, DELETE_USER_FAILURE, GetUsersWithGroupsQuery } from './types';
import * as constants from '../../constants/index'

const getSecurityProfileState = (state: constants.AppState) => state.securityProfile

function* showMessages(action: any) {
    if (action.type === INSERT_OR_UPDATE_USER_GROUPS_SUCCESS || action.type === INSERT_USER_SUCCESS || action.type === INSERT_OR_UPDATE_POLICY_SUCCESS) {
        yield put(showNotification('ra.notification.updated', 'info'));
    } else if (action.type === DELETE_USER_GROUPS_SUCCESS || action.type === DELETE_USER_SUCCESS || action.type === DELETE_POLICY_SUCCESS) {
        yield put(showNotification('ra.notification.deleted', 'info'));
    } else if (action.type === RESET_MFA_SUCCESS) {
        yield all([
            put(showNotification('ra.messages.successfulOperation', 'success')),
        ]);
    } else if (action.type === RESET_MFA_FAILURE) {
        yield all([
            put(showNotification('ra.messages.failedOperation', 'error')),
        ]);
    } else if (action.type.endsWith("_FAILURE")) {
        yield all([
            put(showNotification('ra.page.error', 'error')),
            put(showNotification(action.payload.message, 'error')),
        ]);
    }
    if (action.type === INSERT_OR_UPDATE_USER_GROUPS_SUCCESS || action.type === DELETE_USER_GROUPS_SUCCESS) {
        yield all([
            put(getGroupsWithUsers({ ...userGroupInit }))
        ]);
    }
    if (action.type === INSERT_OR_UPDATE_POLICY_SUCCESS || action.type === DELETE_POLICY_SUCCESS) {
        const securityProfile = (yield select(getSecurityProfileState)) as constants.AppState
        const policy = JSON.parse(JSON.stringify(new Policy())); // deep clone
        policy.pageIndex = 0
        policy.pageSize = securityProfile.userProfile.numberSearchResultList
        yield all([
            put(getFullPolicies(policy)),
            put(getPolicies(policy)),
        ]);
    }
}

export default function* securitySaga() {
    yield takeEvery(INSERT_USER_SUCCESS, showMessages)
    yield takeEvery(INSERT_USER_FAILURE, showMessages)
    yield takeEvery(DELETE_USER_SUCCESS, showMessages)
    yield takeEvery(DELETE_USER_FAILURE, showMessages)
    yield takeEvery(INSERT_OR_UPDATE_USER_GROUPS_SUCCESS, showMessages)
    yield takeEvery(INSERT_OR_UPDATE_USER_GROUPS_FAILURE, showMessages)
    yield takeEvery(DELETE_USER_GROUPS_SUCCESS, showMessages)
    yield takeEvery(DELETE_USER_GROUPS_FAILURE, showMessages)
    yield takeEvery(DELETE_POLICY_SUCCESS, showMessages)
    yield takeEvery(INSERT_OR_UPDATE_POLICY_SUCCESS, showMessages)
    yield takeEvery(INSERT_OR_UPDATE_POLICY_FAILURE, showMessages)
    yield takeEvery(RESET_MFA_SUCCESS, showMessages)
    yield takeEvery(RESET_MFA_FAILURE, showMessages)
}
